import { useAuthStore } from '../stores/useAuthStore';

/**
 * Formatea un precio con el símbolo de moneda del tenant
 * @param amount - El monto a formatear
 * @param decimals - Número de decimales (por defecto 2)
 * @returns String formateado con el símbolo de moneda
 */
export function formatPrice(amount: number, decimals: number = 2): string {
  const { config } = useAuthStore.getState();
  const symbol = config?.currency_symbol || '$';
  return `${symbol}${amount.toFixed(decimals)}`;
}

/**
 * Hook para obtener el símbolo de moneda del tenant
 * @returns El símbolo de moneda configurado o '$' por defecto
 */
export function useCurrencySymbol(): string {
  const { config } = useAuthStore();
  return config?.currency_symbol || '$';
}

/**
 * Hook para obtener el código de moneda del tenant
 * @returns El código de moneda configurado o 'ARS' por defecto
 */
export function useCurrencyCode(): string {
  const { config } = useAuthStore();
  return config?.currency_code || 'ARS';
}
